// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopOrderRequestModel from '../../model/get-shop-order-request-model';
import GetShopOrderRequestDTO from '../dto/get-shop-order-request-dto';
import dtoSchema from '../schemas/get-shop-order-request-schema';

export default abstract class GetShopOrderRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopOrderRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopOrderRequestDTO>): GetShopOrderRequestModel;
  static toModel(dto: DeepPartial<GetShopOrderRequestDTO> | undefined | null): GetShopOrderRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopOrderRequestDTO> | undefined | null): GetShopOrderRequestModel | undefined {
    return dto ? new GetShopOrderRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopOrderRequestModel> | GetShopOrderRequestModel): GetShopOrderRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopOrderRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopOrderRequestModel, can not map to GetShopOrderRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
